import Card from '@/components/Card';
import { classes } from './utils';

export type StepTitleProps = {
  step: number;
};

export default function StepTitle({ step }: StepTitleProps) {
  return (
    <>
      <Card className={classes.card}>
        <div className={classes.title}>{`Step ${step}`}</div>
      </Card>
    </>
  );
}
